// FullView
import React from 'react';
import PropTypes from 'prop-types';

function FullView(props)  {
  return (
    <section className="common-full-view uk-full-height uk-full-width">
      {props.children}
    </section>
  );
}
FullView.propTypes = {
  children: PropTypes.node
};

export default FullView;




// WEBPACK FOOTER //
// ./src/features/common/FullView.js